import axios from "axios";
const url = process.env.REACT_APP_APP_URL;
// const url = "http://htuntaukbackend.kwintechnologies.com:9090/api/";
const storeToken = localStorage.getItem("token");

const apiInstance = axios.create({
  baseURL: url,
  headers: {
    Authorization: `Bearer ${storeToken}`,
  },
});

apiInstance.interceptors.request.use(
  (config) => {
    if (storeToken) {
      config.headers["Authorization"] = `Bearer ${storeToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

apiInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // if (error.response?.status === 401) {
    //   localStorage.removeItem("token");
    //   window.location.href = "/login";
    // }
    return Promise.reject(error);
  },
);

export default apiInstance;
